import EventEmitter from 'eventemitter3';
import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";
import { QuitScene } from "./QuitScene";
import { MuteButton } from "./MuteButton";
import { LocalizationManager } from '../../managers/LocalizationManager';
import { HTPScene } from './HTPScene';
import { GameType } from '../../models/CBNGameModel';
import { GameManager } from '../../managers/GameManager';

export class PauseScene extends Scene{

    container:Phaser.GameObjects.Image|null = null;
    containerLabel:Phaser.GameObjects.Text|null = null;

    playButton:Button|null = null;
    exitButton:Button|null = null;
    muteButton:MuteButton|null = null;

    htpScene:HTPScene|null = null;
    emitter:EventEmitter = new EventEmitter();

    group:Phaser.GameObjects.Group|null = null;
    blackScreen:Phaser.GameObjects.Image|null = null;

    quitScene: QuitScene;
    open:boolean = false;

    htpIndexLength:number;
    
    constructor(sceneConfig,htpIndexLength:number){
        super(sceneConfig);
        this.htpIndexLength = htpIndexLength;
        this.quitScene = new QuitScene({key:'QuitScene'+Math.random()});
    }
    
    prescaleCreate(){
        
        this.events.on('destroy',this.onSceneDestroy,this);
        this.scene.add('QuitScene',this.quitScene,true);
        this.quitScene.emitter.on('close',this.closeQuitScene,this);
        this.quitScene.emitter.on('quit',this.quitQuiz,this);
        this.quitScene.scene.setActive(false);

        let position;
        let style;
        let text;
        let textString;
        let button:Button;
        let image:Phaser.GameObjects.Image;
        let group = this.add.group({});
        this.group = group;

        position = this.scaleManager.getRelativePosition(.5,.5);
        image = this.add.image(position.x,position.y,'gen_overlay');
        image.setAlpha(0.5);
        image.setTint(0x000000);
        image.setInteractive();
        this.blackScreen = image;
        
        position = this.scaleManager.getRelativePosition(0.5,0.5,true);
        image = this.add.image(position.x,position.y,'gfx_pop');
        group.add(image);
        this.container = image;

        text = this.add.text(position.x - 570,position.y - 260,LocalizationManager.getText('GAME_PAUSED'),LocalizationManager.getStyle('GAME_PAUSED'));
        text.setOrigin(0,1);
        group.add(text);
        this.containerLabel = text;

        let htpScene = new HTPScene(this,position,this.htpIndexLength);
        group.addMultiple(htpScene.group.getChildren());
        this.htpScene = htpScene;

        button = new Button(this,'play_button',position.x,position.y+300);
        button.buttonHighlightSprite = 'play_button';
        button.buttonPressedSprite = 'play_button_pressed';
        button.emitter.on('buttonup',this.unpause,this);
        group.addMultiple(button.group.getChildren());
        this.playButton = button;

        button = new Button(this,'exit_button',position.x - 420 ,position.y+300);
        button.buttonHighlightSprite = 'exit_button';
        button.buttonPressedSprite = 'exit_button_pressed';
        this.exitButton = button;
        button.emitter.on('buttonup',this.quit,this);
        group.addMultiple(button.group.getChildren());

        position = new Phaser.Math.Vector2(position.x + 420,position.y + 300);
        let muteButton:MuteButton = new MuteButton(this, position);
        this.group.addMultiple(muteButton.group.getChildren());
        this.muteButton = muteButton;

        if((<GameManager>GameManager.instance).cbnGameConfig!.gameType == GameType.single)
        {
            Phaser.Actions.SetVisible(this.muteButton!.group.getChildren(),false);
        }

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
        
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){
            if(this.htpScene){
                this.htpScene.reorient(landscape);
            }
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-305,position.y-140);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y+160);
                Phaser.Actions.SetXY(this.exitButton!.group.getChildren(),position.x - 220, position.y + 160);
                Phaser.Actions.SetXY(this.muteButton!.group.getChildren(),position.x + 220, position.y + 160);
                if(this.open){
                    let origin = this.container.y;
                    let destination = position.y;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }else{
                    let origin = this.container.y;
                    let destination = position.y-2000;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('lan_gen_bg');
                this.input.setHitAreaFromTexture(this.blackScreen,undefined);
            }
            
        }else{
            if(this.htpScene){
                this.htpScene.reorient(landscape);
            }
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-305,position.y-140);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y+160);
                Phaser.Actions.SetXY(this.exitButton!.group.getChildren(),position.x - 220, position.y + 160);
                Phaser.Actions.SetXY(this.muteButton!.group.getChildren(),position.x + 220, position.y + 160);
                if(this.open){
                    let origin = this.container.y;
                    let destination = position.y;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }else{
                    let origin = this.container.y;
                    let destination = position.y-2000;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('por_gen_bg');
                this.input.setHitAreaFromTexture(this.blackScreen,undefined);
            }
        }
        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.blackScreen!.width * this.blackScreen!.scaleX != window.innerWidth || this.blackScreen!.height * this.blackScreen!.scaleY != window.innerHeight)
        {
            this.blackScreen!.setScale(this.sys.canvas.width/this.blackScreen!.width / ratio! , this.sys.canvas.height/this.blackScreen!.height / ratio!);
        }
    }

    startOpen(){
        this.scene.bringToTop(undefined!);
        this.blackScreen!.setVisible(true);
        this.open = true;
        let origin = this.container!.y;
        let destination = this.scaleManager.getRelativePosition(0.5,0.5,true);
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+=' + (-(origin - destination.y)),
            duration: .5 * 1000,
            ease: 'Power3'
        });
    }

    onSceneResize(event:Phaser.Scene):void {
        this.rescaleBackground();
    }

    onSceneDestroy(){
        this.scene.remove(this.quitScene.scene.settings.key);
    }

    unpause(){
        this.blackScreen!.setVisible(false);
        this.emitter.emit('unpause');
        this.open = false;
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+=-2000',
            duration: 1 * 1000,
            ease: 'Power3'
        });
    }

    quit(){
        this.scene.pause(undefined!);
        this.quitScene.startOpen();
    }

    closeQuitScene(){
        this.scene.resume(undefined!);
    }
    
    quitQuiz(){
        this.scene.sendToBack(undefined!);
        this.emitter.emit('quitquiz');
    }
}